import React from "react";
import { cn } from "@/lib/utils";

interface TabSectionProps {
  children: React.ReactNode;
  className?: string;
}

export const TabSection: React.FC<TabSectionProps> = ({ children, className }) => {
  return (
    <div className={cn("max-w-4xl mx-auto px-4 md:px-6 space-y-8", className)}>
      {children}
    </div>
  );
};